<template>
  <div>
    <!--todo: поправить мета-->
    <vue-headful
      title="Опубликовать объявление | Меркурий онлайн"
      description="Опубликовать объявление"
    />
<!--    <Detail/>-->
    <SellApartmentPage />
  </div>
</template>

<script>
import Detail from '@/components/views/GuestAdvert/Detail'
import SellApartmentPage from '@/components/views/GuestAdvert/SellApartment'

export default {
  name: 'GuestAdvert',
  components: { SellApartmentPage, Detail }
}
</script>

<style scoped>

</style>
